import { isWinNative } from '~/utils/runEnvironmentUtil';

const environment = {
  gaId: process.env.REACT_APP_GA_ID,
  idleThreshold: 180000,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN || '',
  serviceTitle: process.env.REACT_APP_SERVICE_TITLE || 'Dooray!',
  hideExportThreadOrganizationId: process.env.REACT_APP_HIDE_EXPORT_THREAD_ORG_ID,
  isWinNative: () => {
    return isWinNative();
  },
};
export default environment;
